import { TEST_RESULT_QUALITY } from '../constants';

const { EXCELLENT, GOOD, FAIR, POOR, BAD, NOT_FOUND } = TEST_RESULT_QUALITY;

function isBetween(quality, res) {
  return quality.min < res && res < quality.max;
}

function getSupportedStatus(res, audio) {
  return audio ? res.audio.supported : res.video.supported;
}

export function getTestResults(res, errors, audio = false) {
  const supported = res ? getSupportedStatus(res, audio) : false;
  if (!supported || errors) {
    return {
      common: audio ? 'virtualVisit.test.audio' : 'virtualVisit.test.video',
      results: NOT_FOUND,
    };
  }
  const result = audio ? res.audio.mos : res.video.mos;
  const quality = getTestQuality(result);
  return {
    common: audio
      ? 'virtualVisit.test.audioQuality'
      : 'virtualVisit.test.videoQuality',
    results: quality,
  };
}

export function getTestQuality(res) {
  switch (true) {
    case isBetween(EXCELLENT, res):
      return EXCELLENT;
    case isBetween(GOOD, res):
      return GOOD;
    case isBetween(FAIR, res):
      return FAIR;
    case isBetween(POOR, res):
      return POOR;
    default:
      return BAD;
  }
}

export function getNotFoundSelectState(formatMessage) {
  return {
    audio: {
      value: 'mic',
      label: formatMessage({ id: 'virtualVisit.test.noAudio' }),
    },
    video: {
      value: 'video',
      label: formatMessage({ id: 'virtualVisit.test.noVideo' }),
    },
  };
}

const getMinMos = results => {
  const audioMos = results.audio.mos;
  const videoMos = results.video.mos;
  switch (true) {
    case audioMos < videoMos:
      return audioMos;
    case audioMos > videoMos:
      return videoMos;
    default:
      return audioMos;
  }
};

export function getCommonResult(formatMessage, results, error) {
  const audioSupported = results && results.audio.supported;
  const videoSupported = results && results.video.supported;
  const notFound = error || !audioSupported || !videoSupported;
  const mos = !notFound ? getMinMos(results) : 0;

  const audioIcon = !audioSupported || error ? NOT_FOUND.icon : '';
  const videoIcon = !videoSupported || error ? NOT_FOUND.videoIcon : '';
  const quality = !notFound
    ? getTestQuality(mos)
    : { ...NOT_FOUND, id: NOT_FOUND.titleId };

  const title = `${formatMessage({
    id: 'virtualVisit.test.completed',
  })}: ${formatMessage({ id: quality.id })} ${formatMessage({
    id: 'virtualVisit.test.connectivity',
  })}`;

  return {
    title,
    danger: quality.danger,
    videoIcon,
    audioIcon,
  };
}

export function getConnectionResult(results) {
  if (!results) {
    return {
      qualityId: 'virtualVisit.test.deviceNotFound',
      danger: true,
      videoResultId: 'virtualVisit.test.deviceNotFound',
      audioResultId: 'virtualVisit.test.deviceNotFound',
    };
  }

  const quality = getTestQuality(getMinMos(results));
  const audio = getTestResults(results, false, true);
  const video = getTestResults(results, false, false);

  return {
    qualityId: quality.id,
    danger: quality.danger,
    videoResultId: video.results.id,
    audioResultId: audio.results.id,
  };
}



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/utils/getTestResults.js